import React, { useEffect, useState } from "react";
import { useSearchParams, Navigate } from "react-router-dom";
import api from "../../utils/api";
import setAuthToken from "../../utils/setAuthToken";

const AutoLogin = () => {
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState("loading");

  useEffect(() => {
    const code = searchParams.get("code");
    if (!code) {
      setStatus("error");
      return;
    }

    api
      .post("/auth/verify-login-code", { code })
      .then((res) => {
        const { user, access_token } = res.data.data;
        localStorage.setItem("token", access_token.token);
        localStorage.setItem("user", JSON.stringify(user));
        setAuthToken(access_token.token);
        setStatus("success");
      })
      .catch(() => {
        setStatus("error");
      });
  }, [searchParams]);

  if (status === "success") {
    return <Navigate to="/my-programs" replace />;
  }

  if (status === "error") {
    return <Navigate to="/login" replace />;
  }

  return (
    <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}>
      <p>Logging you in...</p>
    </div>
  );
};

export default AutoLogin;
